"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgUncoveredSpot = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 1024 1024", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { d: "M986.5 818.1h-79.3c1.3-3.7 1.9-7.6 1.9-11.6v-79.9c17.1-3.4 30-18.2 30-35.9V495.5h22.5c20.7 0 37.5-16.4 37.5-36.6V401c0-20.2-16.8-36.6-37.5-36.6h-60.2l-32.9-137.6c-13.2-55.4-61.4-94.1-117-94.1h-479c-55.7 0-103.8 38.7-117 94.1l-32.9 137.6H62.5C41.8 364.4 25 380.8 25 401v57.9c0 20.2 16.8 36.6 37.5 36.6H85v195.1c0 17.7 12.9 32.5 30 35.9v79.9c0 4.1.7 8 1.9 11.6H37.5C16.8 818.1 0 834.5 0 854.7s16.8 36.6 37.5 36.6h949.1c20.7 0 37.5-16.4 37.5-36.6s-16.9-36.6-37.6-36.6m-277.8 3H295.2c1.4-4 2.2-8.3 2.2-12.8v-83.8h409v83.8c0 4.5.8 8.8 2.3 12.8M191 364.8l28.7-123.6c5.2-22.6 23.1-38.3 43.4-38.3h473.7c20.3 0 38.1 15.8 43.3 38.3l28.7 123.6zm674.3 77.3v208.2H160.7V442.1zM287.9 629c39.6 0 71.8-32.9 71.8-73.3s-32.2-73.3-71.8-73.3-71.8 32.9-71.8 73.3 32.2 73.3 71.8 73.3m448.2 0c39.6 0 71.8-32.9 71.8-73.3s-32.2-73.3-71.8-73.3-71.8 32.9-71.8 73.3 32.2 73.3 71.8 73.3" })));
const ForwardRef = (0, react_1.forwardRef)(SvgUncoveredSpot);
exports.default = ForwardRef;
